
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Heart,
  UserRound,
  LockKeyhole,
  Eye,
  EyeOff,
  ArrowRight,
  ShieldCheck,
} from "lucide-react";
import "./Login.css";

function BrandLogo() {
  return (
    <div className="sk-logo">
      <div className="sk-logo-symbol">
        <Heart
          className="sk-logo-heart-outer"
          size={54}
          strokeWidth={1.8}
        />
        <Heart
          className="sk-logo-heart-inner"
          size={23}
          fill="currentColor"
        />
      </div>

      <div className="sk-logo-copy">
        <div className="sk-logo-tamil">
          <span>சேலம்</span> <strong>கொங்கு</strong>
        </div>

        <div className="sk-logo-caption">
          <i />
          திருமண தகவல் மையம்
          <i />
        </div>
      </div>
    </div>
  );
}

export default function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("Admin@123");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    // Static login credentials for UI development
    const staticUsername = "admin";
    const staticPassword = "Admin@123";

    if (
      username.trim() === staticUsername &&
      password === staticPassword
    ) {
      // Redirect to Dashboard after successful login
      navigate("/dashboard", { replace: true });
    } else {
      setError("Invalid username or password. Please try again.");
    }
  };

  return (
    <main className="sk-login-page">
      {/* Left branding section */}
      <section className="sk-login-brand-panel">
        <div className="sk-login-brand-top">
          <BrandLogo />
        </div>

        <div className="sk-login-brand-content">
          <p className="sk-login-eyebrow">
            <span />
            KONGU VELLALAR MATRIMONY
          </p>

          <h1>
            Bringing hearts
            <br />
            <span>together.</span>
          </h1>

          <p className="sk-login-description">
            Manage members, matrimonial profiles, branches,
            <br className="sk-desktop-break" />
            memberships and meaningful matches from one
            powerful platform.
          </p>

          <div className="sk-login-benefits">
            <span>
              <ShieldCheck size={16} />
              Trusted profile management
            </span>

            <span>
              <Heart size={16} />
              Meaningful connections
            </span>
          </div>
        </div>

        <p className="sk-login-copyright">
          © {new Date().getFullYear()} Salem Kongu Matrimony.
          All rights reserved.
        </p>

        <div className="sk-login-decoration sk-login-decoration-one" />
        <div className="sk-login-decoration sk-login-decoration-two" />
      </section>

      {/* Right login form */}
      <section className="sk-login-form-panel">
        <div className="sk-login-form-wrap">
          <div className="sk-login-mobile-logo">
            <BrandLogo />
          </div>

          <div className="sk-login-heading">
            <span className="sk-login-form-kicker">
              ADMINISTRATION PORTAL
            </span>

            <h2>Welcome Back</h2>
            <p>Sign in to your admin account</p>
          </div>

          <form onSubmit={handleSubmit}>
            <label htmlFor="admin-username">
              Username
            </label>

            <div className="sk-login-input-wrap">
              <UserRound size={17} />

              <input
                id="admin-username"
                name="username"
                type="text"
                autoComplete="username"
                placeholder="Enter username"
                value={username}
                onChange={(event) => {
                  setUsername(event.target.value);
                  setError("");
                }}
                required
              />
            </div>

            <label
              htmlFor="admin-password"
              className="sk-login-password-label"
            >
              Password
            </label>

            <div className="sk-login-input-wrap">
              <LockKeyhole size={17} />

              <input
                id="admin-password"
                name="password"
                type={showPassword ? "text" : "password"}
                autoComplete="current-password"
                placeholder="Enter password"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                  setError("");
                }}
                required
              />

              <button
                type="button"
                className="sk-login-show-password"
                aria-label={
                  showPassword ? "Hide password" : "Show password"
                }
                onClick={() =>
                  setShowPassword((current) => !current)
                }
              >
                {showPassword ? (
                  <EyeOff size={18} />
                ) : (
                  <Eye size={18} />
                )}
              </button>
            </div>

            {error && (
              <p className="sk-login-message" role="alert">
                {error}
              </p>
            )}

            <button
              className="sk-login-submit"
              type="submit"
            >
              Sign In
              <ArrowRight size={16} />
            </button>
          </form>

          <p className="sk-login-portal-caption">
            Salem Kongu Matrimony Admin Portal
          </p>

          <p className="sk-login-security-note">
            <ShieldCheck size={14} />
            Authorized administrators only
          </p>
        </div>
      </section>
    </main>
  );
}
